const _getAnimationDurationinMs = (element) => {
    const { animationDuration } = window.getComputedStyle(element);
    const _float = parseFloat(animationDuration);

    return isNaN(_float)
        ? 0
        : _float * (animationDuration.includes("ms") ? 1 : 1000);
};

const _observer = new IntersectionObserver((entries) => {
    entries
        .filter((entry) => entry.isIntersecting)
        .map((entry) => entry.target)
        .forEach((element, i) => {
            setTimeout(() => {
                element.classList.add("reveal");
                setTimeout(() => {
                    element.classList.remove("reveal");
                    element.classList.add("reveal-complete");
                }, 100 + _getAnimationDurationinMs(element));
            }, 125 * i);
            _observer.unobserve(element);
        });
});

const _observe = (element) => {
    const toObserve = element.querySelectorAll(element.dataset.animateReveal);

    toObserve.forEach((element) => {
        if (!element.classList.contains("reveal-complete")) {
            _observer.unobserve(element);
            _observer.observe(element);
        }
    });
};

const initialize = debounce((element) => {
    _observe(element);
    element.querySelectorAll("[data-animate-reveal]").forEach(_observe);
}, 100);

initialize(document.body);
document.addEventListener("html-update", (event) => {
    const element = event.target.closest("[data-animate-reveal]");

    element && initialize(element);
    event.target.querySelectorAll("[data-animate-reveal]").forEach(initialize);
});

export { initialize, _observe };
